export const apiConfig = {
  b2cScopes: ["https://precisionsportstech.onmicrosoft.com/2f9aaa4e-3025-4f82-8cdc-c4fd3192108d/openid", "https://precisionsportstech.onmicrosoft.com/2f9aaa4e-3025-4f82-8cdc-c4fd3192108d/offline_access"],
  apiUrl: process.env.VUE_APP_WEB_API,
}